import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { EvLinkNavigationTabs } from '@evinced-private/ui-common';

import {
	createDashboardTabOptions,
	getActiveTabFromPath
} from '../../helpers/TabNavigationHelpers';

import './DashboardTabsNav.scss';

export const DashboardTabsNav: FC = () => {
	const history = useHistory();
	const { pathname } = useLocation();

	const activeTabId = getActiveTabFromPath(pathname);
	const options = createDashboardTabOptions(history);

	return (
		<div className="dashboard-tabs-nav">
			<EvLinkNavigationTabs selectedTabId={activeTabId} options={options} />
		</div>
	);
};
